// Input only type ...
export enum TagGroupAutoColumnGq {
  KEYWORD = 'KEYWORD',
  TRANSLATION_ENGLISH = 'TRANSLATION_ENGLISH',
  TRANSLATED_FROM_KEYWORD = 'TRANSLATED_FROM_KEYWORD',
}
